import { render, staticRenderFns } from "./ModalFooter.vue?vue&type=template&id=2b0abccc&scoped=true&"
import script from "./ModalFooter.vue?vue&type=script&lang=js&"
export * from "./ModalFooter.vue?vue&type=script&lang=js&"
import style0 from "./ModalFooter.vue?vue&type=style&index=0&id=2b0abccc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0abccc",
  null
  
)

export default component.exports